export enum PermissionTypes {
  ViewGameSettings = 1,
  ModifyGameSettings = 2,
  ViewReports = 3,
  ViewCharities = 4,
  ModifyCharities = 5,
  ViewPlayerInfo = 6,
  ModifyPlayerInfo = 7,
  ViewAdminUsers = 8,
  ModifyAdminUsers = 9,
  ModifyPlayerNumbers = 10,
  ViewPlayerTransactions = 11,
  ViewGameSummaryReport = 12,
  ViewPlayerNumbers = 13,
  ViewAuditingReport = 14,
  ViewSalesPerGameReport = 15,
  ViewHourlyTicketSalesReport = 16,
  ViewLotteryLicenseReport = 19,
  ViewRolesAndPermissions = 20,
  ModifyRolesAndPermissions = 21,
  ModifySensitiveGameSettings = 22,
  RecalculateGameTotals = 23,
  AdminUpdatePlayerBasicInfo = 24,
  UpdatePlayerActivationStatus = 17,
  ViewComprehensiveGameReport = 18,
  ViewAdminAudits = 25,
  ViewPlayerAudits = 26,
  ViewSystemAudits = 27,
  ViewAuditing = 28,
  DrawGameWinner = 29,
  SendEmailBlast = 30,
  CreateNewGame = 31,
  EditGameTermsOfService = 32,
  EditGameHowToPlay = 33,
  ModifyLotteryLicence = 34,
  AddPlayerNote = 35,
  UpdatePlayerNote = 36,
  ModifyTestimonials = 401,
  ModifyWebappFrequentlyAskedQuestions = 402,
  ModifyPlayerSuspensions = 502,
  ViewPlayerSuspensions = 503,
  DeactivateCharities = 403,
  ReactivateCharities = 404,
  ViewWinnerPayouts = 405,
  ModifyWinnerPayouts = 406,
  ViewGlobalPlayerSearch = 504,
  ViewSendgridData = 505,
  RemoveSendgridSuppressions = 506,
  ViewPlayerNotes = 407,
  ViewPlayerPledges = 408,
  CausableAdminOnly = 999,
  ViewSupportRequests = 507,
  ModifySupportRequests = 508,
  HandleEscalatedSupportRequests = 509,
  ViewGameCharitySupporterBreakdown = 409,
  StripeAccountManagement = 301,
  ViewEmailConfirmations = 510,
  AddOrModifyCharityAdmins = 511,
  MovePlayersToAnotherCharity = 512,
  ViewBroadcastNotifications = 513,
  ModifyBroadcastNotifications = 514,
  ViewPlayerWinningsInformation = 515,
  PauseGameInstance = 517,
  ForceDrawWinner = 518,
  ViewFailedRefunds = 519,
  ViewDuplicateCardFingerprints = 520,
  IssueRefund = 302,
  StopGame = 305,
  EndGame = 306,
  ViewPlayerRefunds = 303,
  ViewSalesSummaryByPricePointReport = 304,
  DownloadPlayerReceipts = 308,
  ViewGameSummaryReportByDateRange = 410,
  ModifyAdminAppFrequentlyAskedQuestions = 601,
  ViewCharityPayouts = 602,
  ModifyCharityPayouts = 603,
  ViewPayoutReport = 604,
  ExportPlayerEmails = 605,
  ViewSystemErrorMessages = 607,
  ModifyErrorMessages = 606,
  ViewDynamicReport = 608,
  ViewGamePayoutRules = 609,
  ModifyGamePayoutRules = 610,
  ViewCharityAdjustments = 611,
  ModifyCharityAdjustments = 612
}
